import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type { CoachingCoacheeCohortMessagesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/messages';
import { markPartnershipConversationRead } from '@efdigital/ll-xceed-v2/utils/coaching/mark-partnership-conversation-read';
import type { PartnershipConversation } from '@efdigital/ll-xceed-v2/utils/coaching/partnership-messages';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoacheeCohortMessagesConversationModel = {
  conversation: PartnershipConversation;
  conversations: PartnershipConversation[];
  program_id: string;
  cohort_id: string;
};

export default class CoachingCoacheeCohortMessagesConversationRoute extends Route<CoachingCoacheeCohortMessagesConversationModel> {
  @service declare session: SessionService;
  @service declare store: Store;

  model({
    partnership_id,
  }: {
    partnership_id: string;
  }): CoachingCoacheeCohortMessagesConversationModel {
    const parent = this.modelFor(
      'coaching.coachee.cohort.messages'
    ) as CoachingCoacheeCohortMessagesModel;
    const conversation = parent.conversations.find(
      (candidate) => candidate.partnership.id === partnership_id
    );

    if (!conversation) {
      throw new Error(`Conversation not found: ${partnership_id}`);
    }

    return {
      conversation,
      conversations: parent.conversations,
      program_id: parent.program_id,
      cohort_id: parent.cohort_id,
    };
  }

  async afterModel(model: CoachingCoacheeCohortMessagesConversationModel) {
    await markPartnershipConversationRead(
      model.conversation,
      'coachee',
      this.session.cached.userId!,
      this.store
    );
  }
}
